/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:16 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");

    var CategoriesComparators = [];

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesComparators = [
            {
                name:"name",
                func: function(model){
                    return model.get(model.KEYS.NAME);
                }
            },
            {
                name:"order",
                func:function(model){
                    return model.get(model.KEYS.ORDER);
                }
            },
            {
                name:"proposed",
                func:function(model){
                    return (model.get(model.KEYS.PROPOSED)) ? 1 : 2;
                }
            },
            {
                name:"assignedContent",
                func:function(model){
                    return model.get(model.KEYS.ASSIGNED_CONTENT);
                }
            },
            {
                name:"assignedCampaigns",
                func:function(model){
                    return model.get(model.KEYS.ASSIGNED_CAMPAIGNS);
                }
            }
        ];
    });

    return CategoriesComparators;
});
